import {useState} from "react";
import {getEquipmentByUniqueCode} from "../../services/Administrative/equipmentService";

export const useGetEquipmentByUniqueCode = () => {
    const [equipment, setEquipment] = useState<any>(null);

    const fetchEquipmentByUniqueCode = async (equipmentId: number) => {
        try {
            const response:any = await getEquipmentByUniqueCode(equipmentId);
            setEquipment(response);
        } catch (error) {
            console.error('Error fetching equipment');
        }
    }

    return { equipment, fetchEquipmentByUniqueCode };
};
